import { IconFont, Select } from '@byecode/ui'
import styled from 'styled-components'

export const Text = styled.span<{ size?: number; color?: string }>`
    font-size: ${({ size }) => size ?? 14}px;
    color: ${({ color }) => color ?? 'var(--color-black)'};
`

export const Icon = styled(IconFont)<{ size?: number }>`
    font-size: ${({ size }) => size ?? '16'}px;
`

export const RightFill = styled.div`
    align-items: center;
    justify-content: flex-end;
`
